import { Component } from '@angular/core';
import { ThemeService } from '../service/theme.service';


@Component({
    selector: 'app-loading-element',
    templateUrl: './loading-element.component.html',
    styleUrl: './loading-element.component.css',
    standalone: false
})

export class LoadingElementComponent {

  // Initial animation class
  fadeInOutClass = 'fade-in';

  // Constructor with injected ThemeService
  constructor(public theme: ThemeService,) {}
}
